import { pantalla } from '../actions';
import { getConfigGeneral, getPantalla, getPantallaProps } from '../selectors';
export default function activarAtajosModoTrabajo(store) {
  var recordarPantalla = function recordarPantalla(tag) {
    var _getConfigGeneral = getConfigGeneral(store.getState()),
        key = _getConfigGeneral.key;

    var pantallaId = window.localStorage.getItem('' + key + tag + '-pantallaId');
    var props = JSON.parse(window.localStorage.getItem('' + key + tag + '-props'));
    store.dispatch(pantalla(pantallaId, props));
  };

  var guardarPantalla = function guardarPantalla(tag) {
    var state = store.getState();
    var configGeneral = getConfigGeneral(state);
    var pantalla = getPantalla(state);
    var pantallaProps = getPantallaProps(state, pantalla);
    window.localStorage.setItem('' + configGeneral.key + tag + '-pantallaId', pantalla);
    window.localStorage.setItem('' + configGeneral.key + tag + '-props', JSON.stringify(pantallaProps));
  };

  window.addEventListener('beforeunload', function () {
    return guardarPantalla('ultima');
  });
  window.addEventListener('keydown', function (event) {
    switch (event.key) {
      case 'F6':
        recordarPantalla('ultima');
        return;

      case 'F1':
        guardarPantalla('usuario');
        return;

      case 'F2':
        recordarPantalla('usuario');
        return;

      default:
    }
  });
}